module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_chap1#c1",
      "id": "toc1"
    }
  }, [_vm._v("The First Word: "), _c('i', [_vm._v("The Value of Ignorance")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_chap2#c2",
      "id": "toc2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Word: "), _c('i', [_vm._v("The Secret of Sanctity")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_chap3#c3",
      "id": "toc3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Word: "), _c('i', [_vm._v("The Fellowship of Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap4#c4",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth Word: "), _c('i', [_vm._v("Confidence in Victory")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap5#c5",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fifth Word: "), _c('i', [_vm._v("Religion is a Quest")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap6#c6",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sixth Word: "), _c('i', [_vm._v("The Hour")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap7#c7",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seventh Word: "), _c('i', [_vm._v("The Purpose of Life")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355d9dfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_contents.vue
// module id = 66
// module chunks = 0